"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _mixins = require("../mixins");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var tabPropTypes = {
  /** Title for the tab button */
  title: _propTypes["default"].string,
  /** Value passed to the function called when tab is clicked
   * Also used for initialActive tab
   */
  value: _propTypes["default"].string,
  /** When `true` tab is not clickable */
  disabled: _propTypes["default"].bool,
  /** Content for tab panel - if there is any */
  children: _propTypes["default"].node
};
var TabPanel = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Tab__TabPanel",
  componentId: "sc-1axmvzz-0"
})(["display:none;padding:", ";", ";", ""], function (props) {
  return props.theme.layouts.p;
}, _mixins.paddingMixin, function (props) {
  return props.isActive && (0, _styledComponents.css)(["display:block;"]);
});

/* Tab Component ************************************ */
var Tab = function Tab(props) {
  return /*#__PURE__*/_react["default"].createElement(TabPanel, props);
};
Tab.propTypes = tabPropTypes;
var _default = Tab;
exports["default"] = _default;